(function () {
    window.AP = window.AP || {};
    window.IS_PROD = (window.location.href.indexOf('prod') > -1);

    String.prototype.camelCaseSplit = function () {
        // insert a space before all caps
        return this.replace(/([A-Z])/g, ' $1')
            // uppercase the first character
            .replace(/^./, function (str) {
                return str.toUpperCase();
            });
    };

    String.prototype.firstUpper = function () {
        return this.substr(0, 1).toUpperCase() + this.substr(1);
    };

    String.prototype.splitCharAndUpper = function (char) {
        if (!char) {
            char = '-';
        }

        return this.replace(new RegExp(char, "g"), ' ').firstUpper();
    };

    AP.Analytics = function(opts) {
        const gaOpts = Object.assign({
                  eventCategory: 'apro',
                  eventAction: 'click',
                  eventLabel: 'ap-label',
                  transport: 'beacon'
              }, opts);

        if (typeof ga === 'function') {
            ga('send', 'event', {
                eventCategory: gaOpts.eventCategory,
                eventAction: gaOpts.eventAction,
                eventLabel: gaOpts.eventLabel,
                transport: gaOpts.transport
            });
        }
    }

    AP.Flags = {};
    AP.Flags.upgrade = true;
    AP.Flags.expire = true;
    AP.Flags.newEditor = true;

    AP.DEBUG = false;
}());



// WEBPACK FOOTER //
// ./app/utils/globals-configs.js